import script from "./Main-Profile-Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Profile-Badge.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__